"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapIvalToMonths = void 0;
const models_1 = require("../models");
const mapIvalToMonths = (ival) => {
    switch (ival) {
        case models_1.PriceIntervalEnum.MONTHLY:
            return 1;
        case models_1.PriceIntervalEnum.QUARTERLY:
            return 3;
        case models_1.PriceIntervalEnum.YEARLY:
            return 12;
        default:
            throw new Error(`Cannot map ival: ${ival} to months`);
    }
};
exports.mapIvalToMonths = mapIvalToMonths;
